import {Button} from '~library/atoms/Button';
import {Typography} from '~library/atoms/Typography';
import {DiamondIcon} from '~library/svg/DiamondIcon';
import {CloseLineIcon} from '~library/svg/CloseLineIcon';

export const PremiumPreviewNav = ({
  isLargishAndUp,
  onClosePremiumPreviewClick,
  toggleUpsellModal,
}) => (
  <nav className="fabric-header__premium_preview_nav">
    <div className="premium-preview">
      <DiamondIcon ratio={1.25} />
      <Typography
        variant={isLargishAndUp ? 'paragraph2' : 'list1'}
        classNames="premium-preview-text--top"
      >
        {isLargishAndUp
          ? 'You are previewing a Premium feature. Like what you see?'
          : 'Premium preview'}
      </Typography>
      {!isLargishAndUp && <span style={{flex: '1 1 100%'}} />}
      <Typography variant="paragraph2" classNames="premium-preview-text--bottom">
        {!isLargishAndUp && 'Like what you see?'}
        <Button
          data-qa-id="upgrade-to-save"
          data-impression-tracking="true"
          variant="link"
          size={isLargishAndUp ? 'large' : 'small'}
          onClick={() => toggleUpsellModal(true, 'unlock-design-tools')}
        >
          Upgrade now
        </Button>
      </Typography>
    </div>
    <Button
      variant="link"
      data-qa-id="close-premium-preview"
      data-impression-tracking="true"
      onClick={onClosePremiumPreviewClick}
    >
      <CloseLineIcon ratio={0.75} />
    </Button>
  </nav>
);
